<template>
  <div class="page_container_wrapper">
    <div class="page_container">
      <transition name="fade-in-up">
        <step-intro
          v-if="activeStep === 'intro'"
          step-name="intro"
        ></step-intro>
        <step-thanks v-if="allStepsCompleted"></step-thanks>
      </transition>
    </div>
  </div>
</template>

<script>
import StepIntro from './intro/';
import StepThanks from './thanks/';

export default {
  name: 'ApplicationsSellerSteps',
  components: {
    StepIntro,
    StepThanks,
  },
  computed: {
    activeStep() {
      return this.$store.getters['seller/getActiveStep'];
    },
    allStepsCompleted() {
      return this.$store.getters['seller/getAllStepsCompleted'];
    },
  },
};
</script>
